
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

interface RateLimitStore {
  [key: string]: {
    count: number;
    lastReset: number;
  };
}

const store: RateLimitStore = {};

export const rateLimit = (key: string, limit: number = 10, windowMs: number = 60000): boolean => {
  const now = Date.now();
  
  if (!store[key]) {
    store[key] = { count: 1, lastReset: now };
    return true;
  }

  const record = store[key];

  if (now - record.lastReset > windowMs) {
    record.count = 1;
    record.lastReset = now;
    return true;
  }

  if (record.count >= limit) {
    return false;
  }

  record.count++;
  return true;
};
